import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import Machines from './pages/Machines';
import MachineDetail from './pages/MachineDetail';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Parts from './pages/Parts';
import CutLists from './pages/CutLists';
import CutListDetail from './pages/CutListDetail';
import Production from './pages/Production';
import Settings from './pages/Settings';
import Users from './pages/Users';

// Protected Route Component - checks authentication
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Role Protected Route Component - checks role access
// allowedRoles: array of roles that can access this route (empty = all authenticated users)
const RoleRoute = ({ children, allowedRoles = [] }) => {
  const { user } = useSelector((state) => state.auth);
  const userRole = user?.role || 'viewer';

  // If no roles specified, allow all authenticated users
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check if user's role is in the allowed roles
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Toegankelijk voor alle ingelogde gebruikers */}
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:id" element={<OrderDetail />} />

        {/* Alleen voor admin en operator */}
        <Route path="machines" element={<RoleRoute allowedRoles={['admin', 'operator']}><Machines /></RoleRoute>} />
        <Route path="machines/:id" element={<RoleRoute allowedRoles={['admin', 'operator']}><MachineDetail /></RoleRoute>} />
        <Route path="products" element={<RoleRoute allowedRoles={['admin', 'operator']}><Products /></RoleRoute>} />
        <Route path="products/:id" element={<RoleRoute allowedRoles={['admin', 'operator']}><ProductDetail /></RoleRoute>} />
        <Route path="parts" element={<RoleRoute allowedRoles={['admin', 'operator']}><Parts /></RoleRoute>} />
        <Route path="cutlists" element={<RoleRoute allowedRoles={['admin', 'operator']}><CutLists /></RoleRoute>} />
        <Route path="cutlists/:id" element={<RoleRoute allowedRoles={['admin', 'operator']}><CutListDetail /></RoleRoute>} />
        <Route path="production" element={<RoleRoute allowedRoles={['admin', 'operator']}><Production /></RoleRoute>} />

        {/* Alleen voor admin */}
        <Route path="settings" element={<RoleRoute allowedRoles={['admin']}><Settings /></RoleRoute>} />
        <Route path="users" element={<RoleRoute allowedRoles={['admin']}><Users /></RoleRoute>} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
